import { useParams } from "react-router-dom";
import { useProtectedRouteSession } from "../../shared/session/useProtectedRouteSession";
import { OperatorPageScaffold } from "../../shared/ui/protected/OperatorPageScaffold";
import { GENERIC_TENANT_LABELS, getTenantLabels } from "../../shared/lib/tenantLabels";
import { buildTeacherPageLinks, TeacherAccessState } from "./teacherUi";

export function TeacherAbsenceRequestPage() {
  const { tenantSlug = "unknown-tenant" } = useParams();
  const { routeStatus, sessionStatus, session, errorMessage, isSessionReady } = useProtectedRouteSession(tenantSlug);
  const hasTeacherRole = Boolean(session?.member?.roles.includes("teacher"));
  const hasAdminRole = Boolean(session?.member?.roles.includes("admin"));
  const tenantLabels = session ? getTenantLabels(session.tenant.uiLabelProfile) : GENERIC_TENANT_LABELS;
  const pageLinks = buildTeacherPageLinks(hasAdminRole, tenantLabels);

  return (
    <OperatorPageScaffold
      currentArea="teacher"
      tenantSlug={tenantSlug}
      tenantName={session?.tenant.displayName}
      session={session}
      title="欠勤申請"
      description="欠勤・代講の申請導線です。"
      links={pageLinks}
    >
      <div style={{ display: "grid", gap: 16 }}>
        <TeacherAccessState
          routeStatus={routeStatus}
          sessionStatus={sessionStatus}
          errorMessage={errorMessage}
          hasTeacherRole={hasTeacherRole}
          labels={tenantLabels}
        />

        {isSessionReady && hasTeacherRole ? (
          <div style={{ display: "grid", gap: 8 }}>
            <p style={{ margin: 0 }}>欠勤申請は準備中です。急ぎの場合は管理者へ連絡してください。</p>
            <p style={{ margin: 0, fontSize: 14, opacity: 0.8 }}>
              admin による schedule 編集は引き続き管理画面で行います。
            </p>
          </div>
        ) : null}
      </div>
    </OperatorPageScaffold>
  );
}
